/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingProduct
 */
export interface BillingProduct {
    /**
     * 
     * @type {number}
     * @memberof BillingProduct
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingProduct
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BillingProduct
     */
    lookupKey: string;
    /**
     * 
     * @type {string}
     * @memberof BillingProduct
     */
    type: BillingProductTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BillingProduct
     */
    features: Array<BillingProductFeaturesEnum> | null;
}

/**
* @export
* @enum {string}
*/
export enum BillingProductTypeEnum {
    AddOn = 'Add-On',
    OneOff = 'One-Off',
    Plan = 'Plan'
}
/**
* @export
* @enum {string}
*/
export enum BillingProductFeaturesEnum {
    Absence = 'Absence',
    Availability = 'Availability',
    ClockInOut = 'Clock In/Out',
    Dashboard = 'Dashboard',
    Documents = 'Documents',
    Employees = 'Employees',
    HrManagement = 'HR Management',
    Integrations = 'Integrations',
    Leave = 'Leave',
    MultiVenue = 'MultiVenue',
    Reports = 'Reports',
    Scheduler = 'Scheduler',
    ShiftAreas = 'Shift Areas',
    TeamMessaging = 'Team Messaging',
    Timesheets = 'Timesheets'
}


/**
 * Check if a given object implements the BillingProduct interface.
 */
export function instanceOfBillingProduct(value: object): value is BillingProduct {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('lookupKey' in value) || value['lookupKey'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    return true;
}

export function BillingProductFromJSON(json: any): BillingProduct {
    return BillingProductFromJSONTyped(json, false);
}

export function BillingProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'lookupKey': json['lookupKey'],
        'type': json['type'],
        'features': json['features'] == null ? null : json['features'],
    };
}

  export function BillingProductToJSON(json: any): BillingProduct {
      return BillingProductToJSONTyped(json, false);
  }

  export function BillingProductToJSONTyped(value?: BillingProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'lookupKey': value['lookupKey'],
        'type': value['type'],
        'features': value['features'],
    };
}

